import { TABS_USER } from '..'
import { forgotPassword } from 'Hooks/useAuth'
import { useMediaQuery } from 'react-responsive'
import { BREAKPOINT } from 'Utils/const/breakPoints'
import TableUserContentDesktop from './TableUserContentDesktop'
import TableUserContentMobile from './TableUserContentMobile'
import { PROFILE_DETAILS_ROUTER } from 'constant/router'
import { PERMISSION_BY_ROLE } from 'Utils/permissionByRol'
import { ROLE_ADMIN_NAME } from 'constant/roles'
import useSessionStore from 'Context/useSessionStore'

const ROLE_SUPER_ADMIN_NAME = 'super_admin'
const PROTECTED_TARGET_ROLES = [ROLE_ADMIN_NAME, ROLE_SUPER_ADMIN_NAME]

const TableUserList = ({
  listUsers,
  activeTab,
  openUserModal,
  onDelete,
  onAssignTempPassword = () => {},
  selectable = false,
  selectedIds = [],
  onToggleSelect = () => {}
}) => {
  const { user: UserContext } = useSessionStore((state) => ({ user: state.user }))

  // Media query
  const isMobile = useMediaQuery({
    query: `(max-width: ${BREAKPOINT.MOBILE})`
  })

  const canAssignTempPassword = PERMISSION_BY_ROLE.USER.ASSIGN_TEMP_PASSWORD.includes(UserContext?.role)

  const forgotPasswordUser = async (email) => {
    forgotPassword(email).catch((e) => {
      console.error(e)
    })
  }

  const buildMenuOptions = (user) => [
    activeTab === TABS_USER.ACTIVE.name && {
      id: 1,
      actions: [
        {
          id: 1,
          onClick: ({ element }) => { window.location.href = (PROFILE_DETAILS_ROUTER({ profileId: element.id })) },
          name: 'View profile'
        },
        {
          id: 2,
          onClick: ({ element }) => openUserModal(element.id),
          name: 'Edit user'
        },
        {
          id: 3,
          onClick: ({ element }) => forgotPasswordUser(element.email),
          name: 'Reset password'
        },
        canAssignTempPassword && !PROTECTED_TARGET_ROLES.includes(user?.role) && {
          id: 6,
          onClick: ({ element }) => onAssignTempPassword(element),
          name: 'Assign temp password'
        }
      ].filter((x) => x)
    },
    user?.id !== UserContext?.id && {
      id: 2,
      actions: [
        {
          id: 4,
          name: activeTab === TABS_USER.ACTIVE.name ? 'Deactivate' : 'Reactivate',
          onClick: ({ element }) => onDelete({ user: element }),
          styles: activeTab === TABS_USER.ACTIVE.name ? 'text-danger' : ''
        },
        activeTab === TABS_USER.ARCHIVED.name && {
          id: 5,
          name: 'Delete',
          onClick: ({ element }) => onDelete({ user: element, deleteU: true }),
          styles: 'text-danger'
        }
      ]
    }
  ].filter((x) => x)

  return (
    <div className="col-12">
      <div className="card mb-3 p-4 users-card">
        <div className="table-responsive users-card">
          {!isMobile && (
            <TableUserContentDesktop
              listUsers={listUsers}
              menuOptions={buildMenuOptions}
              selectable={selectable}
              selectedIds={selectedIds}
              onToggleSelect={onToggleSelect}
            />
          )}
          {isMobile && <TableUserContentMobile listUsers={listUsers} menuOptions={buildMenuOptions} />}
        </div>
      </div>
    </div>
  )
}

export default TableUserList
